module.exports = __webpack_public_path__ + "img/건강노화힐링산업.8fc7a8e3.png";